export { NavItemsStateInterface, NavItemsState } from './nav-items-state.model';
